export default __webpack_public_path__ + "static/media/animation.067de29f.png";